import {IMessageCode} from './IMessageCode';

export class GenericMessageBuilder {
message: string;
messageCode: IMessageCode;
}

